export default "__VITE_ASSET__CFSlpguA__"